import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Util } from '../../../utils/util';
import { ReceiptsService } from '../receipts.service';
import { Detail } from '../models/details';
import { Auth } from '../../../autentication/Auth';
import { isAgreementCode } from '../../../validator/validateBarcode';
import parseBarCode from '../../../parser/parseBarCode';



@Component({
	selector: 'app-bankslip-receipt',
	templateUrl: './bankslip-receipt.component.html',
	styleUrls: ['./bankslip-receipt.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class BankslipReceiptComponent implements OnInit {
    source: string;
    receipt: Detail;
	digitableLine: string = "";

	constructor(
		private router: Router,
		private route: ActivatedRoute,
        private receiptsService: ReceiptsService,
	) {}

	ngOnInit(): void {
		this.getReceipt();

		if(!isAgreementCode(this.receipt.codeBar)){
			this.digitableLine = this.receipt.codeBar;
			return;
		}

		this.digitableLine = parseBarCode(this.receipt.codeBar).code;
	}

	getReceipt() {
		this.receipt = this.receiptsService.getSelectedReceipt();
	}


	goBack = () => this.router.navigate(['comprovantes/']);
	emitNew = () => this.router.navigate(['comprovantes/']);
	emitPrint = () => window.print();

	get myDocument(){
		return Auth.getInstance().getUser().cpfCnpj ? Auth.getInstance().getUser().cpfCnpj : Auth.getInstance().getUser().cpf;
	}
	

	getCpfCnpj(cpfCnpj: string) {
		return Util.maskCpfCnpjPix(cpfCnpj);
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/receipts/bankslip-receipt/bankslip-receipt.component.ts